import React from 'react'

interface PhoneMockupProps {
  children: React.ReactNode
  className?: string
}

export const PhoneMockup: React.FC<PhoneMockupProps> = ({ children, className = '' }) => {
  return (
    <div className={`relative mx-auto ${className}`} style={{ maxWidth: '390px' }}>
      {/* Phone Frame */}
      <div className="relative bg-gray-900 rounded-[3rem] p-4 shadow-2xl">
        {/* Notch */}
        <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-40 h-7 bg-gray-900 rounded-b-3xl"></div>
        
        {/* Screen */}
        <div className="bg-white rounded-[2.5rem] overflow-hidden relative" style={{ aspectRatio: '9/19.5' }}>
          {/* Status Bar */}
          <div className="absolute top-0 left-0 right-0 bg-white z-10 px-8 py-2 flex items-center justify-between text-xs">
            <span className="font-medium">9:41</span>
            <div className="flex items-center gap-1">
              {/* Signal */}
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
                <path d="M2 17h2v5H2zm4-7h2v12H6zm4-3h2v15h-2zm4-3h2v18h-2zm4 0h2v18h-2z"/>
              </svg>
              {/* WiFi */}
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
                <path d="M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3c-1.65-1.66-4.34-1.66-6 0zm-4-4l2 2c2.76-2.76 7.24-2.76 10 0l2-2C15.14 9.14 8.87 9.14 5 13z"/>
              </svg>
              {/* Battery */}
              <svg className="w-6 h-4" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17 4h3c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2h-3V4zM4 6c0-1.1.9-2 2-2h9v14H6c-1.1 0-2-.9-2-2V6z"/>
              </svg>
            </div>
          </div>
          
          {/* Content */}
          <div className="h-full w-full overflow-y-auto pt-8 scrollbar-hide">
            {children}
          </div>
        </div>
        
        {/* Home Indicator */}
        <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 w-32 h-1 bg-gray-400 rounded-full"></div>
      </div>
      
      {/* Side Buttons */}
      <div className="absolute -left-1 top-24 w-1 h-8 bg-gray-800 rounded-l-lg"></div>
      <div className="absolute -left-1 top-36 w-1 h-16 bg-gray-800 rounded-l-lg"></div>
      <div className="absolute -left-1 top-56 w-1 h-16 bg-gray-800 rounded-l-lg"></div>
      <div className="absolute -right-1 top-44 w-1 h-20 bg-gray-800 rounded-r-lg"></div>
    </div>
  )
}